import React from 'react';
import { Books } from "../../assets/imageAssets";
import { Link } from "react-router-dom";
import { ArrowUpRight } from '@untitledui/icons/ArrowUpRight';

const QuizTestCard = ({title, href, key}) => {
    return (
        <Link to={href} className='quiz-card' key={key}>
            <div className="quiz-card-image">
                <img src={Books} alt={title} />
            </div>
            <div className="quiz-card-title">
                <div className="icon">
                    <ArrowUpRight size={24} />
                </div>
                <h6>{title}</h6>
            </div>
        </Link>
    );
}

export default QuizTestCard;